import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import 'antd/dist/antd.css';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import * as Sentry from '@sentry/react';
import App from 'App';
import 'index.css';

import translationTW from './assets/languages/tw.json';
import translationEN from './assets/languages/en.json';

// Sentry.init({
//   dsn: 'https://48bd0265fc904095a4035422d3bc4145@o83917.ingest.sentry.io/4504959207079936',
//   environment: process.env.REACT_APP_ENV || 'dev'
// });

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    lng: 'vi',
    supportedLngs: ['en', 'vi'],
    resources: {
      en: {
        translation: translationEN
      },
      vi: {
        translation: translationTW
      }
    },
    fallbackLng: 'vi',
    debug: false,
    detection: {
      order: ['sessionStorage', 'cookie'],
      caches: ['sessionStorage', 'cookie'],
      lookupLocalStorage: 'i18next'
    }
  });
ReactDOM.render(
  <BrowserRouter basename="/user">
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);
